const FriendlyFractionDenominatorSpec = {
	content: "inline*",
	selectable:false,
	toDOM: () => ['span',{class:"friendlyFraction-denominator"},0],
	parseDOM: [{
		tag: 'span.friendlyFraction-denominator'}]
}

export default FriendlyFractionDenominatorSpec